import classNames from "classnames";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";

import { formWrapper } from "../../utils";


const Input = ({
  input: { onChange, value, onBlur, onFocus, name },
  meta: { touched, error } = {},
  style, // eslint-disable-line no-unused-vars
  className,
  multiline,
  rows,
  type,
  disabled,
  placeholder,
  inputProps,
}) => {
  if (type === "hidden") {
    return <input type="hidden" name={name} value={value ?? ""} onChange={e => onChange(e.target.value)} />;
  }
  const hasError = touched && !!error;
  return (
    <div className={classNames("croField", { "croField--error": hasError }, className)}>
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        multiline={multiline}
        rows={rows}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={e => onChange(e.target.value)}
        onBlur={e => onBlur && onBlur(e.target.value)}
        onFocus={onFocus}
        name={name}
        error={hasError}
        helperText={hasError ? error : undefined}
        inputProps={{
          ...inputProps,
          'aria-label': inputProps?.['aria-label'] ?? placeholder ?? 'Hledat',
          "autocomplete": "off"
        }}
      />
    </div>
  );
};

export const FormattedNumberInput = formWrapper(NumericFormat);

export const FormattedMuiInput = ({
  input: { onChange, value, name },
  meta: { touched, error } = {},
  thousandSeparator,
  decimalSeparator,
  isNumericString,
  disabled,
  normalize,
  format,
}) => {
  const hasError = touched && !!error;
  return (
    <div className={classNames("croField", { "croField--error": hasError })}>
      <NumericFormat
        customInput={TextField}
        variant="outlined"
        size="small"
        fullWidth
        value={value ?? ""}
        onChange={e => onChange(e.target.value)}
        name={name}
        disabled={disabled}
        error={hasError}
        helperText={hasError ? error : undefined}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        isNumericString={isNumericString}
      />
    </div>
  );
};

export default Input;
